var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.uiComponentName)?[_c(_vm.uiComponentName,{tag:"component",attrs:{"remoteState":_vm.remoteState}})]:[_vm._v(" No corresponding form component found ")]],2)}
var staticRenderFns = []

export { render, staticRenderFns }